'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Api = require('../../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Actions = require('../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _ScheduleScreenStore = require('../../stores/ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _Constants = require('../Constants');

var Constants = _interopRequireWildcard(_Constants);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _SpinButton = require('../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

var _sweetalert = require('sweetalert2');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReOrder = function (_React$Component) {
    _inherits(ReOrder, _React$Component);

    function ReOrder(props) {
        _classCallCheck(this, ReOrder);

        var _this = _possibleConstructorReturn(this, (ReOrder.__proto__ || Object.getPrototypeOf(ReOrder)).call(this, props));

        _this.calculateUnitPrice = function (chosenOptions, itemPrice, optionCategories) {

            var unitPrice = itemPrice;

            chosenOptions.forEach(function (cOption) {
                var key = cOption.category;
                var idx = _lodash2.default.findIndex(optionCategories, function (option) {
                    return option.category.trim() == key.trim();
                });

                var additionalPrice = 0.0;

                cOption.selectedKeys.forEach(function (val, index) {
                    if (optionCategories[idx].options) {
                        var optionObject = optionCategories[idx].options.find(function (x) {
                            var compareVal = _lodash2.default.keys(x)[0];
                            if (compareVal.trim() === val.trim()) {
                                val = compareVal;
                                cOption.selectedKeys[index] = compareVal;
                                return true;
                            }
                        });
                        additionalPrice += optionObject[val].price;
                    } else {
                        additionalPrice += optionCategories[idx][val];
                    }
                });

                unitPrice += additionalPrice;
            });

            return unitPrice;
        };

        _this.regenerateOptionCategories = function (orderItem) {

            return orderItem.itemOptionCategories.map(function (optionCategory) {
                var categoryName = optionCategory.optionCategoryName;
                var selectedKeys = optionCategory.selectedKeys.map(function (selectedKey) {
                    return selectedKey.split("-")[0].trim();
                });

                return { "category": categoryName, "selectedKeys": selectedKeys };
            });
        };

        _this.regenerateTipDetails = function (tipAmount, subTotal) {

            if (tipAmount === 0) {
                _Actions2.default.addTip(0, "notip", null);
                return;
            }

            var tipPercentage = _lodash2.default.round(tipAmount * 100 / subTotal, 0);

            // console.log(tipPercentage);

            if (tipPercentage == 10) {
                _Actions2.default.addTip(tipAmount, "percent", 10);
            } else if (tipPercentage == 15) {
                _Actions2.default.addTip(tipAmount, "percent", 15);
            } else if (tipPercentage == 20) {
                _Actions2.default.addTip(tipAmount, "percent", 20);
            } else {
                _Actions2.default.addTip(tipAmount, "custom", null);
            }
        };

        _this.isResturantOpen = function () {
            var openHours = [];

            if (_this.state.locationDetail) {
                openHours = _this.state.locationDetail.openHours;
            }

            return Utils.isResturantOpen(openHours);
        };

        _this.isItemAvailableForReorder = function (order) {
            var liveItemDetailsMap = _MainStore2.default.getLiveItemDetailsMap();

            var availableItems = order.items.filter(function (orderItem) {
                var itemDetail = liveItemDetailsMap[orderItem.itemObjectId];
                var groupDetail = itemDetail ? itemDetail.groupDetailPointer : null;
                var locationDetail = _this.state.locationDetail;
                var isGroupAvailable = true;

                var openHours = locationDetail ? locationDetail.openHours : [];

                if (groupDetail && groupDetail.openHours) {
                    openHours = groupDetail.openHours;
                }

                if (openHours) {
                    // get date time based on the location
                    var dateTime = _MainStore2.default.getCurrentDateTime();

                    isGroupAvailable = Utils.isResturantOpen(openHours, dateTime);
                }
                return isGroupAvailable;
            });

            return availableItems.length === order.items.length;
        };

        _this.getOrderLocation = function (locId) {

            var index = 0;
            var locationDetail = _MainStore2.default.data.BusinessLocations.filter(function (location, idx) {
                if (location.objectId == locId) {
                    index = idx;
                    return true;
                }
            });

            return [locationDetail, index];
        };

        _this.addToCartForReorderWrapper = function () {

            var locationDetail = _this.state.locationDetail;
            //  const activeLocation = MainStore.data.LocationDetail;
            var activeLocation = _MainStore2.default.getActiveLocation();
            var dineInOnly = _MainStore2.default.isLocationForDineInOnly();

            var order = _this.state.order;

            if (dineInOnly && order.orderType !== Constants.DINEIN) {

                _sweetalert2.default.fire({
                    title: 'Dine In only available',
                    text: 'You can only place DineIn order.',
                    icon: 'warning',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: 'Close',
                    customClass: {
                        cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                    },
                    allowOutsideClick: false
                });

                return;
            }

            if (!(activeLocation.objectId == order.locationDetailPointer.objectId)) {
                _this.reOrderChangesLocation();
                return;
            }

            _this.addToCartForReorder();
        };

        _this.getMessage = function (invalidItems, totalPastOrders) {

            if (invalidItems.length === totalPastOrders) {
                return 'Reorder items : ' + invalidItems.join(', ') + ' are not live or discontinued!';
            }

            if (invalidItems.length > 1) {
                return 'Items are added to cart for re-ordering. Some reorder items : ' + invalidItems.join(', ') + ' are not live or discontinued!';
            } else {
                return 'Items are added to cart for re-ordering. Reorder item : ' + invalidItems.join(', ') + ' is not live or discontinued!';
            }
        };

        _this.state = {
            order: null,
            locationDetail: null
        };

        return _this;
    }

    _createClass(ReOrder, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.setState({
                order: this.props.order,
                locationDetail: this.props.locationDetail
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps) {
                this.setState({
                    order: nextProps.order,
                    locationDetail: nextProps.locationDetail
                });
            }
        }

        // Not used

    }, {
        key: 'reOrderChangesLocation',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _this2 = this;

                var order, locDetailsArray, orderLocationDetail, activeLocation, locationDetail, locationIndex, msg;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                order = this.state.order;
                                locDetailsArray = this.getOrderLocation(order.locationDetailPointer.objectId);
                                orderLocationDetail = this.state.locationDetail;
                                //const activeLocation = MainStore.data.LocationDetail;

                                activeLocation = _MainStore2.default.getActiveLocation();
                                locationDetail = locDetailsArray[0];
                                locationIndex = locDetailsArray[1];

                                if (locationDetail) {
                                    _context.next = 9;
                                    break;
                                }

                                _sweetalert2.default.fire({
                                    title: 'Location is closed',
                                    text: 'This location is not available to order!',
                                    icon: 'warning',
                                    showConfirmButton: false,
                                    showCancelButton: true,
                                    cancelButtonText: 'Close',
                                    customClass: {
                                        cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                                    },
                                    allowOutsideClick: false
                                });

                                return _context.abrupt('return');

                            case 9:
                                msg = "This order location: \n" + Utils.getAddressStrFromLocation(orderLocationDetail) + "\nis different than your current set location: \n" + Utils.getAddressStrFromLocation(activeLocation) + " .\nDo you want to continue?";
                                _context.next = 12;
                                return _sweetalert2.default.fire({
                                    title: "Warning",
                                    text: msg,
                                    icon: 'warning',
                                    showCancelButton: true,
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: 'Yes',
                                    cancelButtonText: 'No',
                                    customClass: {
                                        confirmButton: "bg-styl",
                                        cancelButton: "swal2-confirm custom-btn-outline-primary custom-primary"
                                    },
                                    allowOutsideClick: false

                                }).then(function (result) {
                                    if (result.isConfirmed) {
                                        _MainStore2.default.getAllData(locationIndex, null, _this2.addToCartForReorder);
                                        _Actions2.default.resetCustomChargeDataOfCart();
                                        _Actions2.default.clearScheduleScreenStore(false);
                                        _CartStore2.default.clearCartStore();
                                    }
                                });

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function reOrderChangesLocation() {
                return _ref.apply(this, arguments);
            }

            return reOrderChangesLocation;
        }()
    }, {
        key: 'addToCartForReorder',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this3 = this;

                var liveItemDetailsMap, order, totalPastOrders, invalidItems, subTotal, isGroupAvailable, confirmAwait, disablePickupOrder, scheduleObj, isLocationCurbsidePickup, confirm, _scheduleObj2, _scheduleObj3, isDineInEnabled, _scheduleObj4, _confirm;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                liveItemDetailsMap = _MainStore2.default.getLiveItemDetailsMap();
                                order = this.state.order;
                                totalPastOrders = order.items.length;
                                invalidItems = [];
                                subTotal = 0;
                                isGroupAvailable = true;

                                if (!(_CartStore2.default.getCartCount() !== 0)) {
                                    _context2.next = 12;
                                    break;
                                }

                                _context2.next = 9;
                                return _sweetalert2.default.fire({
                                    title: "Do you want to continue?",
                                    text: "Previous cart items will be cleared!",
                                    icon: 'warning',
                                    showCancelButton: true,
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: 'Yes',
                                    cancelButtonText: 'No',
                                    customClass: {
                                        confirmButton: "bg-styl",
                                        cancelButton: "swal2-confirm custom-btn-outline-primary custom-primary"
                                    },
                                    allowOutsideClick: false

                                }).then(function (result) {
                                    if (result.isConfirmed) {
                                        _Actions2.default.clearScheduleScreenStore(false);
                                        _CartStore2.default.clearCartStore();
                                        return true;
                                    } else if (result.isDismissed) {
                                        return false;
                                    }
                                });

                            case 9:
                                confirmAwait = _context2.sent;

                                if (confirmAwait) {
                                    _context2.next = 12;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 12:
                                if (!(order.orderType == Constants.PICKUP)) {
                                    _context2.next = 23;
                                    break;
                                }

                                // check the pick up ordering is enabled or not for location
                                disablePickupOrder = _MainStore2.default.isPickUpOrderDisabled();

                                if (!disablePickupOrder) {
                                    _context2.next = 21;
                                    break;
                                }

                                _sweetalert2.default.fire({
                                    title: 'Pick Up Not Available',
                                    text: 'Pick Up ordering is disabled.',
                                    icon: 'warning',
                                    showConfirmButton: false,
                                    showCancelButton: true,
                                    cancelButtonText: 'Close',
                                    customClass: {
                                        cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                                    },
                                    allowOutsideClick: false
                                });

                                _Actions2.default.clearScheduleScreenStore(false);
                                _CartStore2.default.clearCartStore();

                                return _context2.abrupt('return');

                            case 21:
                                scheduleObj = {
                                    orderType: order.orderType,
                                    scheduledDate: _ScheduleScreenStore2.default.getScheduledDate()
                                };


                                _ScheduleScreenStore2.default.updateScheduleScreenData(scheduleObj);

                            case 23:
                                if (!(order.orderType == Constants.PICKUP && !Utils.isEmptyObj(order.curbsidePickup))) {
                                    _context2.next = 35;
                                    break;
                                }

                                isLocationCurbsidePickup = _CartStore2.default.isLocationCurbsidePickupEnabled();

                                if (isLocationCurbsidePickup) {
                                    _context2.next = 33;
                                    break;
                                }

                                _context2.next = 28;
                                return _sweetalert2.default.fire({
                                    title: "Do you want to continue?",
                                    text: "Previous cart items will be cleared!",
                                    icon: 'warning',
                                    showCancelButton: true,
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: 'Yes',
                                    cancelButtonText: 'No',
                                    customClass: {
                                        confirmButton: "bg-styl",
                                        cancelButton: "swal2-confirm custom-btn-outline-primary custom-primary"
                                    },
                                    allowOutsideClick: false

                                }).then(function (result) {
                                    if (result.isConfirmed) {
                                        var _scheduleObj = {
                                            orderType: order.orderType,
                                            isPreferCurbside: false,
                                            vColor: null,
                                            vMakeModel: null,
                                            scheduledDate: _ScheduleScreenStore2.default.getScheduledDate()
                                        };

                                        _ScheduleScreenStore2.default.updateScheduleScreenData(_scheduleObj);
                                        return true;
                                    } else if (result.isDismissed) {
                                        _Actions2.default.clearScheduleScreenStore(false);
                                        _CartStore2.default.clearCartStore();
                                        return false;
                                    }
                                });

                            case 28:
                                confirm = _context2.sent;

                                if (confirm) {
                                    _context2.next = 31;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 31:
                                _context2.next = 35;
                                break;

                            case 33:
                                _scheduleObj2 = {
                                    orderType: order.orderType,
                                    isPreferCurbside: true,
                                    vColor: order.curbsidePickup.vMakeModel,
                                    vMakeModel: order.curbsidePickup.vColor,
                                    scheduledDate: _ScheduleScreenStore2.default.getScheduledDate()
                                };


                                _ScheduleScreenStore2.default.updateScheduleScreenData(_scheduleObj2);

                            case 35:

                                //update delivery order details in schedule store
                                if (order.orderType == Constants.DELIVERY) {
                                    _CartStore2.default.setDeliveryFee(order.deliveryFee);

                                    _scheduleObj3 = {
                                        orderType: order.orderType,
                                        deliveryAddressObj: {
                                            name: order.userInfo.name,
                                            phoneNumber: order.userInfo.phone,
                                            addLine1: order.userInfo.deliveryAddLine1,
                                            addLine2: order.userInfo.deliveryAddLine2,
                                            city: order.userInfo.deliveryCity,
                                            country: "",
                                            state: order.userInfo.deliveryState,
                                            zipCode: order.userInfo.deliveryZip
                                        },
                                        scheduledDate: _ScheduleScreenStore2.default.getScheduledDate()

                                    };


                                    _ScheduleScreenStore2.default.updateScheduleScreenData(_scheduleObj3);
                                }

                                // check the DineIn is enabled or not for location

                                if (!(order.orderType == Constants.DINEIN)) {
                                    _context2.next = 47;
                                    break;
                                }

                                isDineInEnabled = _MainStore2.default.isDineInEnabled();

                                if (isDineInEnabled) {
                                    _context2.next = 45;
                                    break;
                                }

                                _sweetalert2.default.fire({
                                    title: 'Dine In Not Available',
                                    text: 'Dine-In ordering is disabled.',
                                    icon: 'warning',
                                    showConfirmButton: false,
                                    showCancelButton: true,
                                    cancelButtonText: 'Close',
                                    customClass: {
                                        cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                                    },
                                    allowOutsideClick: false
                                });

                                //reset schedulescreenstore
                                _Actions2.default.clearScheduleScreenStore(false);
                                // clear the cart store
                                _CartStore2.default.clearCartStore();
                                return _context2.abrupt('return');

                            case 45:
                                _scheduleObj4 = {
                                    orderType: order.orderType,
                                    sldata: order.dineIn.slData
                                    // scheduledDate    : ScheduleScreenStore.getScheduledDate()
                                };


                                _ScheduleScreenStore2.default.updateScheduleScreenData(_scheduleObj4);

                            case 47:

                                order.items.forEach(function (orderItem) {

                                    // fetch the item based on the itemName instead on the itemObjectId
                                    var itemDetail = Utils.filterByProperty(liveItemDetailsMap, "itemName", orderItem.itemName);

                                    if (itemDetail) {

                                        var origOptionCategories = itemDetail.optionCategories;
                                        var newOptionCategories = _this3.regenerateOptionCategories(orderItem);
                                        var itemPrice = _this3.calculateUnitPrice(newOptionCategories, itemDetail.itemPrice, origOptionCategories);
                                        var cartItem = {
                                            itemObjectId: itemDetail.objectId,
                                            itemOrderInst: orderItem.itemOrderInst,
                                            itemPrice: itemPrice,
                                            itemOptionCategories: newOptionCategories,
                                            itemQty: orderItem.itemQty
                                        };

                                        subTotal += itemPrice * cartItem.itemQty;

                                        _Actions2.default.addItemToCart(itemDetail.objectId, cartItem, itemDetail);
                                    } else {
                                        invalidItems.push(orderItem.itemName);
                                    }
                                });

                                if (!(invalidItems.length != order.items.length && order.subTotal != subTotal)) {
                                    _context2.next = 51;
                                    break;
                                }

                                _context2.next = 51;
                                return _sweetalert2.default.fire({
                                    title: "Warning",
                                    text: "Cart sub total has been changed!",
                                    icon: 'warning',
                                    showConfirmButton: false,
                                    showCancelButton: true,
                                    cancelButtonColor: '#d33',
                                    cancelButtonText: 'Close',
                                    customClass: {
                                        cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel" + " custom-primary text-capitalize"
                                    },
                                    allowOutsideClick: false
                                });

                            case 51:

                                this.regenerateTipDetails(order.tipAmount, subTotal);

                                // Actions.addDeliveryAddress(order.orderType, {}, Number.NaN);

                                _Actions2.default.addOrderInstructions(order.orderInstructions);

                                // this.updateScheduleScreenStore(order);

                                if (!(invalidItems.length !== 0)) {
                                    _context2.next = 59;
                                    break;
                                }

                                _context2.next = 56;
                                return _sweetalert2.default.fire({
                                    title: "Warning",
                                    text: '' + this.getMessage(invalidItems, totalPastOrders),
                                    icon: 'warning',
                                    showConfirmButton: false,
                                    showCancelButton: true,
                                    cancelButtonColor: '#d33',
                                    cancelButtonText: 'Close',
                                    customClass: {
                                        cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel" + " custom-primary text-capitalize"
                                    },
                                    allowOutsideClick: false
                                }).then(function (result) {
                                    if (result.isDismissed) {
                                        return false;
                                    }
                                });

                            case 56:
                                _confirm = _context2.sent;

                                if (_confirm) {
                                    _context2.next = 59;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 59:

                                if (invalidItems.length != order.items.length) {
                                    Utils.showSpinner();
                                    setTimeout(function () {
                                        _this3.handleShowCartScreen();
                                    }, 1000);
                                }

                            case 60:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function addToCartForReorder() {
                return _ref2.apply(this, arguments);
            }

            return addToCartForReorder;
        }()
    }, {
        key: 'handleShowCartScreen',
        value: function handleShowCartScreen() {
            var history = this.props.history;

            var locId = this.props.locId;

            history.push('/location/' + locId + '/checkout');
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_SpinButton2.default, {
                classNames: 'btn btn-sm btn-styl font-weight-bold',
                buttonText: 'REORDER',
                spinText: "Loading...",
                showSpinner: false,
                whenClicked: this.addToCartForReorderWrapper,
                showIcon: true,
                iconClass: "icofont-refresh mr-1",
                tabIndex: 12 + this.props.idx
            });
        }
    }]);

    return ReOrder;
}(_react2.default.Component);

// ReOrder.contextTypes = {
//     router : React.PropTypes.object.isRequired
// }


exports.default = ReOrder;


//////////////////
// WEBPACK FOOTER
// ./src/components/order/ReOrder.jsx
// module id = 548
// module chunks = 0